



















































































































































































































































































































































































































































// TODO: Enable lint.
/* eslint-disable */
import { computed, defineComponent, onMounted, reactive, ref, SetupContext } from '@vue/composition-api';
import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';
import axios from 'axios';
import Fuse from 'fuse.js';
import moment from 'moment';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import NavHeader from '@/components/NavHeader.vue';
import Footer from '@/components/Footer.vue';

type Image = {
  id: string,
  name: string,
  url: string,
};

type Concept = {
	id: string,
	project_id: string,
	cp_template_id: string,
	name?: string,
	title?: string,
	description?: string,
  image_vertical_size?: number,
	topbox?: number,
	sum_of_top2box?: number,
	created_at: string,
	updated_at: string,

  concept_image_id: string,
  cpcard_image_id: string,

  project_name: string,

  cpcard_image: Image,
};


type Project = {
  id: string,	
	organization_id: string,
	user_id: string,       
	name: string,         
	supplemental_memo: string,
	internal_memo: string,
  default_cp_template_id: string,
	is_archived: boolean,
	created_at: string,    
	updated_at: string,

  concepts: Concept[],
};

async function loadImage(data: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e: Event) => {
      resolve(reader.result as string);
    };
    reader.readAsDataURL(data);
  });
};

export default defineComponent({
  name: "ProjectList",
  components: {
    Loading,
    NavHeader,
    Footer,
  },
  head: {
    link: [
      { rel: 'stylesheet', type: 'text/css', href: '/css/style.css' }
    ],
    script: [
      { src: "https://ajax.googleapis.com/ajax/libs/jquery/1.7/jquery.min.js" },
      { src: "/js/toggle_contents.js" }
    ]
  },
  filters: {
    moment: function(date: string) {
      moment.locale('ja')
      return moment(date).format('YYYY/MM/DD')
    },
    shorten: function(id: string) {
      if (id === null ) return '';
      if (id.length > 7)
        return id.substring(0, 7).toUpperCase();
      else
        return id;
    },
    ommit: function(memo: string) {
      if (memo && memo.length > 24)
        return memo.slice(0, memo.length - 1) + '...';
      else
        return memo;
    }
  },

  setup(_, context: SetupContext) {
    const batchOps = [ { op: 'archive', name: 'アーカイブ' }, { op: 'delete', name: '削除' } ];
    const state = reactive({
      loading: false,
      selectedOp: batchOps[0],
      projects: [] as Project[], // TODO: computedに変更する
      allProjects: [] as Project[],
      selecteds: [] as Project[],
      focusedProject: { name: '', concepts: [] as Concept[] } as Project,
    })

    // allProjects => filter => sort => page分割 => projects(current)
    const filter = ref('');
    const fuseOptions = {
      keys: ['name', 'supplemental_memo']
    };
    const pageSize = 10;
    const currentPage = ref(1);
    const pages = computed(() => {
      //const projs = state.allProjects;
      const projs = ((ps: Project[], fv: string) => {
        if (fv.trim() === '') {
          return ps;
        } else {
          const fuse = new Fuse(state.allProjects, fuseOptions);
          return fuse.search(filter.value).map(r => { return r.item });
        }
      })(state.allProjects, filter.value);

      return projs.reduce(
        (pgs, _, i) => (i % pageSize ? pgs : [...pgs, projs.slice(i, i + pageSize)]), 
        [] as Project[][]
      );
    });
    const projects = computed(() => {
      return pages.value[currentPage.value - 1];
    });
    const fromNum = computed(() => {
      if (state.allProjects.length === 0) {
        return state.allProjects.length;
      } else {
        return (currentPage.value - 1) * pageSize + 1;
      }
    });
    const toNum = computed(() => {
      const to = (currentPage.value - 1) * pageSize + pageSize
      if (to > state.allProjects.length) {
        return state.allProjects.length;
      } else {
        return to;
      }
    });

    // concepts in dialog
    const cpPageSize = 6;
    const cpCurrentPage = ref(1);
    const cpPages = computed(() => {
      const cps = state.focusedProject.concepts;
      return cps.reduce(
        (pgs, _, i) => (i % cpPageSize ? pgs : [...pgs, cps.slice(i, i + cpPageSize)]), 
        [] as Concept[][]
      );
    });
    const concepts = computed(() => {
      if (cpPages.value.length > 0) {
        return cpPages.value[cpCurrentPage.value - 1];
      } else {
        return [];
      }
    });
    const cpFromNum = computed(() => {
      const cps = state.focusedProject.concepts;
      if (cps.length === 0) {
        return cps.length;
      } else {
        return (cpCurrentPage.value - 1) * cpPageSize + 1;
      }
    });
    const cpToNum = computed(() => {
      const cps = state.focusedProject.concepts;
      const to = (cpCurrentPage.value - 1) * cpPageSize + cpPageSize
      if (to > cps.length) {
        return cps.length;
      } else {
        return to;
      }
    });


    async function load() {
      state.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      API.get('dev', '/projects', options).then(response => {
        console.log(response);
        state.allProjects = response.data.map((p: any) => {
          if (p.concepts === null) p.concepts = [];
          return p;
        });
        state.projects = state.allProjects;
        console.log(state.projects)
      }).catch(err => {
        console.log(err);
      }).finally(() => {
        state.loading = false;
      });
    }
    load();

    onMounted(() => {
      console.log('ProjectView onMounted!!');
    });

    async function confirmDeletion(...projects: any[]) {
      console.log(projects);
      state.selecteds = projects;
      context.root.$modal.show("deleteConfirmation");
    }

    async function confirmBatchOperation() {
      switch (state.selectedOp.op) {
        case 'delete':
          context.root.$modal.show("deleteConfirmation");
          break;
        case 'archive':
          context.root.$modal.show("archiveConfirmation");
          break;
        default:
          console.log('unknown batch operation');
          console.log(state.selectedOp);
          break;
      }
    }

    async function deleteProject(id: string) {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      API.del('dev', '/projects/' + id, options).then(response => {
        console.log(response);
        load();
      }).catch(err => {
        console.log(err);
      });
    }

    async function deleteSelectedProjects() {
      if (state.selecteds.length > 0) {
        const options = {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
          },
          body: { ids: state.selecteds.map(p => { return p.id; }) }
        }

        // TODO: call /projects with ids instated of /projects/:id 
        // concept/History.vueを参考にチェックボックスも連動させる
        API.del('dev', '/projects', options).then(response => {
          console.log(response);
          context.root.$modal.hide("deleteConfirmation");
          load();
        }).catch(err => {
          console.log(err);
        });
      }
    }

    async function confirmArchiving(...projects: any[]) {
      console.log(projects);
      state.selecteds = projects;
      context.root.$modal.show("archiveConfirmation");
    }

    async function archiveProject(id: string) {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      API.put('dev', '/projects/archives/' + id, options).then(response => {
        console.log(response);
        load();
      }).catch(err => {
        console.log(err);
      });
    }

    async function archiveSelectedProjects() {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      if (state.selecteds.length > 0) {
        API.put('dev', '/projects/archives/' + state.selecteds[0].id, options).then(response => {
          console.log(response);
          context.root.$modal.hide("archiveConfirmation");
          load();
        }).catch(err => {
          console.log(err);
        });
      }
    }

    async function showConcepts(project: Project) {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        },
        queryStringParameters: {  // OPTIONAL
          pid: '',
          cid: ''
        }
      };

      state.focusedProject = project;
      state.focusedProject.concepts = await Promise.all(project.concepts.map(async (cp: Concept) => {
        if (cp.cpcard_image_id) {
          options.queryStringParameters.pid = cp.project_id;
          options.queryStringParameters.cid = cp.id;

          const cpcard = await API.get('dev', '/images/cpcards/' + cp.cpcard_image_id, options);
          cp.cpcard_image = cpcard.data;

          const image = await axios.get(cpcard.data.url, { responseType: 'blob' });
          cp.cpcard_image.url = await loadImage(image.data);
        } else {
          cp.cpcard_image = { id: '', name: '', url: '/images/archive_img.png'};
        }
        return cp;
      }));

      context.root.$modal.show("concepts");
    }

    return {
      batchOps,
      state,

      filter,
      pageSize,
      pages,
      currentPage,
      projects,
      fromNum,
      toNum,

      cpPageSize,
      cpPages,
      cpCurrentPage,
      concepts,
      cpFromNum,
      cpToNum,
       
      confirmArchiving,
      archiveProject,
      archiveSelectedProjects,
      confirmDeletion,
      confirmBatchOperation,
      deleteProject,
      deleteSelectedProjects,
      showConcepts,
    };
  }
});
